import { render, staticRenderFns } from "./ChannelVision.vue?vue&type=template&id=ec0392ca"
import script from "./ChannelVision.vue?vue&type=script&lang=js"
export * from "./ChannelVision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports